import { GROUP_SETTINGS_NAME_REQUEST_ASYNC } from './constants'

const fetchGroupSettingsName = () => ({
  type: GROUP_SETTINGS_NAME_REQUEST_ASYNC.INITIATE,
})
export const fetchGroupSettingsNameSuccess = (data) => ({
  type: GROUP_SETTINGS_NAME_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchGroupSettingsNameError = (error) => ({
  type: GROUP_SETTINGS_NAME_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  fetchGroupSettingsName,
}
